<!-- @Version: 1.1.0 -->
<mat-sidenav-container data-testid="sidenav-container">
   <mat-sidenav #sidenav data-testid="sidenav-header">
      <div class="sidebar-header">
         <app-bank-logo-default data-testid="bank-logo-left"></app-bank-logo-default>
         <button mat-icon-button [color]="TRANSLATE_PATH.COLOR_REDIRECT| translateDesign"  class="close-icon" data-testid="close-sidenav" (click)="sidenav.close()">
            <mat-icon data-testid="close-button">close</mat-icon>
         </button>
      </div>
      
      <app-nav-list data-testid="header-navlist">
         <app-nav-csv-list csv-list [list]="sSidenavNoLogin.csvList" (sidenavClose)="sidenav.close()" data-testid="csv-navlist"></app-nav-csv-list>
         <app-nav-special-list special-list [list]="sSidenavNoLogin.specialList" (sidenavClose)="sidenav.close()" data-testid="special-navlist"></app-nav-special-list>
      </app-nav-list>

   </mat-sidenav>
   <mat-sidenav-content data-testid="sidenav-content">
      <app-blank-no-login [class.no-list]="!sSidenavNoLogin.depsNavShow" (sidenavToggle)="sidenav.toggle()" data-testid="blank">
         <app-nav-csv-list header-nav-csv [list]="sSidenavNoLogin.csvList" data-testid="csv-navlist"></app-nav-csv-list>
         <app-nav-special-list header-nav-special [list]="sSidenavNoLogin.specialList" data-testid="special-navlist"></app-nav-special-list>
      </app-blank-no-login>
   </mat-sidenav-content>
</mat-sidenav-container>